var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "klaviyo-form",
      class: _vm.embedClass,
      attrs: {
        id: _vm.getFormId,
        "data-ajax-submit":
          "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
        action: "//manage.kmail-lists.com/subscriptions/subscribe",
        method: "GET"
      }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "form_type", value: "customer" }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "g" },
        domProps: { value: _vm.listId }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          !_vm.isSuccess
            ? _c("EmailInput", {
                attrs: { id: "k_id_email", placeholder: "Enter email" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "klaviyo_messages" }, [
        _c(
          "div",
          {
            ref: "form_success",
            staticClass:
              "success_message email-capture__notice email-capture__notice--success flex align-start flex-column",
            staticStyle: { display: "none" }
          },
          [
            _c("p", { staticClass: "m-0" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.getSuccessMessage(1)) + "\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "m-0" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.getSuccessMessage(2)) + "\n      "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "error_message text-input__error-notice flex align-center",
          staticStyle: { display: "none" }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }